import { createFileRoute } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { requireCompleteProfile } from "@/lib/auth-guard";
import { pb } from "@/lib/pocketbase";
import { Collections } from "@/types/pocketbase-types";
import type { IArticle } from "@/types/extended-types";
import ArticleDetails from "@/components/application/articles/articleDetails/ArticleDetails";
import LoadingSpinner from "@/components/LoadingSpinner";
import { z } from "zod";

export const Route = createFileRoute("/articles/$slug")({
  ...requireCompleteProfile(),
  validateSearch: z.object({
    summaryLevel: z.string().optional(),
  }),
  component: ArticleDetailsPage,
});

function ArticleDetailsPage() {
  const { slug } = Route.useParams();
  const { summaryLevel } = Route.useSearch();
  // const [summaryLevel, setSummaryLevel] = useState("");

  // Fetch the article by ID
  const {
    data: article,
    isLoading,
    error,
  } = useQuery({
    queryKey: ["article", slug],
    queryFn: async (): Promise<IArticle> => {
      console.log("📄 Fetching article with ID:", slug);
      const record = await pb.collection(Collections.Sources).getOne(slug, {
        expand: "section",
      });
      console.log("✅ Article fetched:", {
        id: record.id,
        title: record.title,
        hasSection: !!record.expand?.section,
      });
      return record as unknown as IArticle;
    },
    enabled: !!slug,
  });

  if (isLoading) {
    return (
      <div className="min-h-screen">
        <LoadingSpinner text="Loading article..." className="min-h-[400px]" />
      </div>
    );
  }

  if (error || !article) {
    return (
      <div className="min-h-screen">
        <div className="text-center py-12">
          <div className="text-error-500 text-6xl mb-4">📰</div>
          <h2 className="text-xl font-bold text-error-500 mb-2">
            Article not found
          </h2>
          <p className="text-neutral-500">
            {error
              ? "Failed to load the article."
              : "The requested article could not be found."}
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="">
      <ArticleDetails article={article} summaryLevel={summaryLevel} />
    </div>
  );
}
